<template>
  <div class="contatiner">
    <div class="bg1">
      <!-- <img class="order-title" :src="orderTitle"/> -->
			订单号查询
    </div>
    <div class="flex-wrap">
     
      <div v-if="hasQuery && no" class="box">
        <div class="label">订单号查询结果</div>
        <div class="phone-wrap">
          <span>激活码：{{no}}</span>
          <!-- <div class="copy" @click="copy($event, no)">复制</div> -->
        </div>
        <div class="btn-query" @click="copy($event, no)">
          复制
        </div>
      </div>
      <div v-if="hasQuery && !no" class="box">
        <div class="label">订单号查询结果</div>
        <div class="text-wrap">
          <div class="text1">你商品未发货哦</div>
          <div class="text1">请稍后再次查询</div>
        </div>
        <!-- <div class="btn-query" @click="reInput">重新输入</div> -->
      </div>
      <van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>
      <div v-if="!hasQuery" class="box" style="margin-top: -40px;">
        <div class="label">输入收货地址订单号查询</div>
        <div class="phone-wrap">
          <span>订单号：</span>
          <input class="input" v-model="phone" />
        </div>
        <div class="btn-query" @click="query">查询</div>
        <div class="help" @click="onZZ">如遇到问题 点击我获取客服</div>
      </div>
      <!-- <div class="footer">
        <div>—— 小白考研 ——</div>
        <div class="text">考研小白的成长之家</div>
      </div> -->
    </div>
		<van-dialog v-model="show" title="客服二维码" show-cancel-button>
		  <img :src="zz" class="zz"/>
		</van-dialog>
  </div>
</template>

<script>
import { Cell, CellGroup, Field, Image, Loading, Button, Notify, NoticeBar, Grid, GridItem, Toast, Icon ,Dialog} from 'vant';
import https from '../../../https'
import orderTitle from '../../../../static/order-title.png'
import zz from '../../../../static/z-z.png'
export default {
  components: {
		[Dialog.Component.name]: Dialog.Component,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [NoticeBar.name]: NoticeBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Icon.name]: Icon
  },
  data () {
    return {
      orderTitle,
			zz,
      hasQuery: false,
      no: '',
      link:'',
      phone: '',
      loading: false,
			show:false,
    };
  },
  created () {

  },
  methods: {
    reInput () {
      this.hasQuery = false
      this.no = ''
      this.phone = ''
    },
    query () {
      var that = this
      if(!that.phone) {
        Notify({ type: 'warning', message: '手机号不能为空哦' });
        return
      }
      
      that.loading = true
      https.fetchGet(`/backend/api/user/exchangeCode/${that.phone}`).then(res => {
        if (res.data && res.data.data && Object.keys(res.data.data).length>0 ) {
          that.hasQuery = true
					console.log( res)
          that.no = res.data.data
          // if(that.no) that.url = that.no.startsWith("9898")?'http://yjcx.chinapost.com.cn/qps/yjcx':'https://www.zto.com/express/expressCheck.html';
          // const wp = res.data.data.wp;
          // const link = wp.split(" ")[0] || 'https://pan.baidu.com/s/1IAt4P2DwOOxT0ObcfbaLqg', ps =  wp.split(" ")[1] || '密码:u3v5'
          // this.link = link;
          // that.ps = ps
          that.loading = false
        } else {
          that.loading = false
          Notify({ type: 'warning', message: '手机号不存在，请重新输入' });
        }
      }).catch(err => {
        that.loading = false
        Notify({ type: 'warning', message: '当前人数过多，请稍后重试' });
        console.log(err)
      })

    },
    copy (e, value) {
      try {
        const input = document.createElement('textarea')
        input.value = value
        document.body.appendChild(input)
        input.select()
        document.execCommand('Copy')
        document.body.removeChild(input)
        Toast.success('复制成功');
      } catch (e) {
        Toast.fail('复制失败');
      }

    },
		onZZ(){
			this.show = true
		},
    feedback() {
      https.fetchPostToken(`/api/logistics/feedback`, { content: '链接失效', type: '链接失效'}).then(res => {
        if (res.data && res.data.data) {
         Notify({ type: 'success', message: '已反馈哦' });
        }
      }).catch(err => {
        Notify({ type: 'warning', message: '反馈提交失败' });
        console.log(err)
      })

    },
  }
};
</script>

<style scoped lang="less">
	.zz{
		width: 200px;
		height: 200px;
		display: block;
		margin: 20px auto;
	}
  .van-loading--vertical{
    position: absolute;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .contatiner{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: linear-gradient(to bottom, #FFF6E3, #FFE096);
    .bg1{
      width: 100%;
      height: 32vh;
      background: url(../../../../static/bg1.png);
      background-size: 100% 100%;
      text-align: center;
			box-sizing: border-box;
			padding-top: 100px;
      .order-title{
        width:  237px;
        height: 73px;
        margin-top: 40px;
      }
    }
    .flex-wrap{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .box{
        width:92vw;
        background:rgba(255,255,255,1);
        border-radius:18px;
        margin: 0 auto;
        padding-bottom: 24px;
				text-align: center;
        .text-wrap{
          padding-bottom: 32px;
          .text1{
            text-align: center;
            color: #929292;
            &:first-child{
              padding-bottom: 10px;
            }
          }
        }
        .label{
          margin: 0 auto;
          padding-top: 35px;
          padding-bottom: 56px;
          text-align: center;
          font-size: 18px;
          color: #333333;
        }
        .baidu-wrap{
          width: 290px;
          padding: 15px;
          margin: 0 auto;
          background: #F3F3F3;
          color: #333;
          font-size: 14px;
          line-height: 24px;
          .baidu{
            font-size: 15px;
          }
          .link{
            color: #0091FF;
            word-break: break-all;
          }
        }
        .phone-wrap{
          position: relative;
          display: flex;
          align-items: center;
          padding-left: 14px;
          width: 290px;
          height: 56px;
          margin: 0 auto;
          background: #F3F3F3;
          .copy{
            position: absolute;
            right: 24px;
            top: 50%;
            transform: translateY(-50%);
            color: #3F94FF;
            font-size: 16px;
          }
          .input{
            flex: 1;
            height: 100%;
            border-width: 0;
            padding-left: 8px;
            background: transparent;
          }
        }
        .btn-query{
          width:290px;
          height:44px;
          margin: 0 auto;
          margin-top: 65px;
          line-height: 44px;
          text-align: center;
          background:linear-gradient(270deg,rgba(255,95,31,1) 0%,rgba(255,136,68,1) 100%);
          box-shadow:0px 5px 9px 0px rgba(255,153,80,0.46);
          border-radius:22px;
          color: #ffffff;
          font-size: 18px;
          .a{
            color: #ffffff;
            font-size: 18px;
          }
        }
        .btn-copy{
          width: 156px;
          margin-top: 24px;
        }
        .feedback{
          font-size: 14px;
          padding-top: 20px;
          color: #FF6322;
          text-align: center;
        }
        .help{
          margin-top: 20px;
          text-align: center;
          font-size: 14px;
					display: inline-block;
          color: #0b60ff;
          border-bottom: 1px solid #0b60ff;
        }
      }
      .footer{
        margin: 0 auto;
        padding-top: 24px;
        padding-bottom: 40px;
        text-align: center;
        color: #9A6A39;
        .text{
          padding-top: 8px;
          text-align: center;
          font-size: 12px;
        }
      }

    }
  }
</style>
